import React, { useState } from "react";
import { CoreButton } from "./komodo";
import TfAddToList from "./TfAddToList";
import { addToCartFlow } from "../utils/cart";
import { getString } from "../utils/localizationHelper";

const Recommendations = ({ recommendedProducts }) => {
  const [cartError, setCartError] = useState(null);

  const handleAddToCart = async (product) => {
    setCartError(null);
    try {
      // Following genomic search UI pattern - cartId handled internally
      const result = await addToCartFlow(product);

      if (result.error) {
        setCartError(result.error);
      }
      // External minicart script handles the UI, no local modal needed
    } catch (err) {
      setCartError("Failed to add to cart.");
      console.error("Add to cart error:", err);
    }
  };

  return (
    <div className="tf-container" id="best-solution">
      <div className="tf-row tf-products">
        {recommendedProducts.length > 0 ? (
          recommendedProducts.map((product, idx) => (
            <div
              className="product tf-col-xs-6 tf-col-sm-6 tf-col-md-4 tf-col-lg-3"
              key={product.sku}
            >
              <div className="tf-result-card">
                <div className="tf-result-card-header">
                  <div className="tf-product-type-banner">{product.label}</div>
                  {product.notes && (
                    <div
                      className="product-notes"
                      dangerouslySetInnerHTML={{ __html: product.notes }}
                    />
                  )}
                </div>
                <div className="tf-result-card-body border-top">
                  <div className="tf-product-image">
                    {product.url ? (
                      <a className="tf-link" href={product.url} target="_self">
                        <img
                          src={
                            product.image.startsWith("data:") ||
                            product.image.endsWith("-250.jpg")
                              ? product.image
                              : product.image + "-250.jpg"
                          }
                          alt={product.name}
                        />
                      </a>
                    ) : (
                      <img
                        src={
                          product.image.startsWith("data:") ||
                          product.image.endsWith("-250.jpg")
                            ? product.image
                            : product.image + "-250.jpg"
                        }
                        alt={product.name}
                      />
                    )}
                  </div>
                  <div className="tf-r-p-col">
                    <div className="product-catalog">
                      {getString("results.catalog_no")} <span>{product.sku}</span>
                    </div>
                    <div className="product-brand">{product.brand}</div>
                    {product.name === "Missing name" ? (
                      <div className="product-name">Product not available</div>
                    ) : (
                      <div className="product-name">
                        {product.url ? (
                          <a
                            className="tf-link"
                            href={product.url}
                            target="_self"
                            dangerouslySetInnerHTML={{ __html: product.name }}
                          />
                        ) : (
                          <span
                            className="no-url"
                            dangerouslySetInnerHTML={{ __html: product.name }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="product-specs">
                  <span className="prod-price">{product.price}</span>
                  {product.size && (
                    <span className="product-size"> | {product.size}</span>
                  )}
                </div>
                <div className="product-cart-buttons">
                  <CoreButton
                    variant="outline"
                    size="small"
                    type="button"
                    onClick={() => handleAddToCart(product)}
                  >
                    <span slot="content">{getString("results.add_to_cart")}</span>
                  </CoreButton>
                  <TfAddToList
                    label={getString("results.add_to_list")}
                    product={product}
                    className="tf-btn tf-btn-small tf-btn-default"
                  />
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div
              className="tf-result-rank-strip__no-results"
              style={{
                textAlign: "center",
                color: "#888",
                padding: "40px 0",
              }}
            >
              <h2>No recommendations found.</h2>
            </div>
          </div>
        )}
      </div>
      {cartError && <div className="cart-error">{cartError}</div>}
    </div>
  );
};

export default Recommendations;
